import formatter from './formatter';
import shoppingCart from './shoppingCart';

const cardUtils = {
  calculatePrice: price => {
    const store = shoppingCart
      .getStores()
      .find(store => store.store === price.store);
    if (price.currency === 'ARS') {
      const priceInUSD =
        store && store.exchangeRate ? price.price / store.exchangeRate : null;
      return priceInUSD !== null
        ? formatter.formatNumber(priceInUSD) +
            ' USD (' +
            formatter.formatNumber(price.price) +
            ' ARS)'
        : formatter.formatNumber(price.price) + ' ARS';
    }
    if (price.currency === 'USD') {
      const priceInARS = store ? price.price * store.exchangeRate : null;
      return priceInARS !== null
        ? formatter.formatNumber(price.price) +
            ' USD (' +
            formatter.formatNumber(priceInARS) +
            ' ARS)'
        : formatter.formatNumber(price.price) + ' USD';
    }
  },

  comparePrice: price => {
    try {
      if (price.priceRank === 1) return 'hidden';
      if (price.priceRank === 2) return 'text-red-500';
      if (price.priceRank === 3) return 'text-yellow-500';
      if (price.priceRank === 4) return 'text-green-500';
      if (!price.priceRank && price.standardPriceTCGPlayer) {
        let priceInUSD;
        if (price.currency === 'ARS')
          priceInUSD = price.price / shoppingCart.getUSDPrice();
        if (price.currency === 'USD') priceInUSD = price.price;
        if (priceInUSD) {
          // If the price is over x1.5 standard price, mark it as expensive
          if (priceInUSD > price.standardPriceTCGPlayer * 1.5)
            return 'text-red-500';
          // If the price is under x0.5 standard price, mark it as cheap
          if (priceInUSD < price.standardPriceTCGPlayer * 0.5)
            return 'text-green-500';
          // Otherwise, mark it as regular
          return 'text-yellow-500';
        }
      }
      return 'hidden';
    } catch (e) {
      return 'hidden';
    }
  },

  // Cheapest stored CardKingdom reference price (USD) for a card, or null when we
  // have none. Reads standardPriceCardKingdom directly rather than
  // standardPriceTCGPlayer, which only mirrors the CardKingdom value when the
  // user's price provider preference is CardKingdom (see server CardPriceUtils).
  cardKingdomPrice: card => {
    const prices = (card && card.cardPrices ? card.cardPrices : [])
      .map(cardPrice => Number(cardPrice.standardPriceCardKingdom))
      .filter(price => price > 0);
    return prices.length ? Math.min(...prices) : null;
  },

  sortPrices: priceList => {
    if (!priceList) return [];
    return priceList
      .filter(
        price =>
          // Filter cards with no stock
          price.stock > 0,
      )
      .sort(function compare(a, b) {
        // Sort by lower price
        if (
          (a.currency === 'USD'
            ? a.price *
              shoppingCart.getStores().find(store => store.store === a.store)
                .exchangeRate
            : a.price) <
          (b.currency === 'USD'
            ? b.price *
              shoppingCart.getStores().find(store => store.store === b.store)
                .exchangeRate
            : b.price)
        ) {
          return -1;
        }
        if (
          (a.currency === 'USD'
            ? a.price *
              shoppingCart.getStores().find(store => store.store === a.store)
                .exchangeRate
            : a.price) >
          (b.currency === 'USD'
            ? b.price *
              shoppingCart.getStores().find(store => store.store === b.store)
                .exchangeRate
            : b.price)
        ) {
          return 1;
        }
        return 0;
      });
  },

  groupCardsByStore: cards => {
    let cardsSortedByStore = [];
    cards.forEach(card => {
      const bestPrice = card.cardPrices
        .filter(cardPrice => cardPrice.stock > 0)
        .sort(function compare(a, b) {
          // Sort by lower price
          if (
            (a.currency === 'USD'
              ? a.price *
                shoppingCart.getStores().find(store => store.store === a.store)
                  .exchangeRate
              : a.price) <
            (b.currency === 'USD'
              ? b.price *
                shoppingCart.getStores().find(store => store.store === b.store)
                  .exchangeRate
              : b.price)
          ) {
            return -1;
          }
          if (
            (a.currency === 'USD'
              ? a.price *
                shoppingCart.getStores().find(store => store.store === a.store)
                  .exchangeRate
              : a.price) >
            (b.currency === 'USD'
              ? b.price *
                shoppingCart.getStores().find(store => store.store === b.store)
                  .exchangeRate
              : b.price)
          ) {
            return 1;
          }
          return 0;
        })[0];
      if (bestPrice) {
        if (!cardsSortedByStore.find(elem => elem.store === bestPrice.store))
          cardsSortedByStore.push({ store: bestPrice.store, cards: [] });
        cardsSortedByStore
          .find(elem => elem.store === bestPrice.store)
          .cards.push(card);
      }
    });

    return cardsSortedByStore.sort((a, b) => a.store.localeCompare(b.store));
  },
};

export default cardUtils;
